import { AccountCircle } from '@mui/icons-material';
import { Avatar as MuiAvatar } from '@mui/material';

import { avatarBackgroundColor, lightBorderColor } from '@/theme';

const sizeMap = {
  dense: 34,
  medium: 40,
  large: 92,
} as const;
const iconSizeMap = {
  dense: 32,
  medium: 22,
  large: 54,
};

export const Avatar = ({
  size,
  src,
}: {
  size: 'dense' | 'medium' | 'large';
  src?: string;
}) => {
  const borderWidth = size === 'dense' ? 1 : 2;
  const sizePx = sizeMap[size];
  const iconSizePx = iconSizeMap[size];

  return (
    <MuiAvatar
      sx={{
        borderRadius: '50%',
        backgroundColor: avatarBackgroundColor,
        border: (theme) =>
          src
            ? `solid ${borderWidth}px ${theme.palette.primary.main}`
            : `${borderWidth}px solid ${lightBorderColor}`,
        width: sizePx,
        height: sizePx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      src={src}
    >
      <AccountCircle
        sx={{
          width: iconSizePx,
          height: iconSizePx,
          color: (theme) => theme.palette.secondary.dark,
        }}
      />
    </MuiAvatar>
  );
};
